module.exports = __webpack_public_path__ + "img/ar.78827b0b.svg";